<div class="volunteer-management-dialog-part">
	<h4>Volunteer Video Management</h4>

	<div class="videos-container">
		@if (hasEnglishVideo()) {
		<div class="video-card">
			<div class="card-body">
				<h6 class="card-title mb-3">
					English
				</h6>

				<div class="card-actions">
					<common-button-row>
						<button type="button" class="btn btn-sm btn-outline-primary"
							(click)="openVideoDialog(englishLanguageId)" title="View Video">
							<i class="fa-regular fa-circle-play me-1"></i>
							View
						</button>
						<button type="button" class="btn btn-sm btn-outline-warning"
							[disabled]="isResetting() || !canManageVolunteer()" (click)="resetVideo(englishLanguageId)"
							title="Reset Video">
							@if (isResetting()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Resetting...
							} @else {
							<i class="fa-regular fa-rotate-left me-1"></i>
							Reset
							}
						</button>
						@if (!hasSpanishVideo()) {
						<button type="button" class="btn btn-sm btn-outline-info"
							[disabled]="isSwitchingLanguage() || !canManageVolunteer()"
							(click)="switchLanguage(englishLanguageId)" title="Switch to Spanish">
							@if (isSwitchingLanguage()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Switching...
							} @else {
							<i class="fa-regular fa-arrows-left-right me-1"></i>
							Switch Language
							}
						</button>
						}
						<button type="button" class="btn btn-sm btn-outline-danger"
							[disabled]="isDeleting() || !canManageVolunteer()" (click)="deleteVideo(englishLanguageId)"
							title="Delete Video">
							@if (isDeleting()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Deleting...
							} @else {
							<i class="fa-regular fa-trash me-1"></i>
							Delete
							}
						</button>
					</common-button-row>
				</div>
			</div>
		</div>
		}

		@if (hasSpanishVideo()) {
		<div class="video-card">
			<div class="card-body">
				<h6 class="card-title mb-3">
					Spanish
				</h6>

				<div class="card-actions">
					<common-button-row>
						<button type="button" class="btn btn-sm btn-outline-primary"
							(click)="openVideoDialog(spanishLanguageId)" title="View Video">
							<i class="fa-regular fa-circle-play me-1"></i>
							View
						</button>
						<button type="button" class="btn btn-sm btn-outline-warning"
							[disabled]="isResetting() || !canManageVolunteer()" (click)="resetVideo(spanishLanguageId)"
							title="Reset Video">
							@if (isResetting()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Resetting...
							} @else {
							<i class="fa-regular fa-rotate-left me-1"></i>
							Reset
							}
						</button>
						@if (!hasEnglishVideo()) {
						<button type="button" class="btn btn-sm btn-outline-info"
							[disabled]="isSwitchingLanguage() || !canManageVolunteer()"
							(click)="switchLanguage(spanishLanguageId)" title="Switch to English">
							@if (isSwitchingLanguage()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Switching...
							} @else {
							<i class="fa-regular fa-arrows-left-right me-1"></i>
							Switch Language
							}
						</button>
						}
						<button type="button" class="btn btn-sm btn-outline-danger"
							[disabled]="isDeleting() || !canManageVolunteer()" (click)="deleteVideo(spanishLanguageId)"
							title="Delete Video">
							@if (isDeleting()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Deleting...
							} @else {
							<i class="fa-regular fa-trash me-1"></i>
							Delete
							}
						</button>
					</common-button-row>
				</div>
			</div>
		</div>
		}

		@if (!hasEnglishVideo() && !hasSpanishVideo()) {
		<div class="text-center text-muted py-3">
			No videos found
		</div>
		}
	</div>
</div>